import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const breadcrumbsStatic = [{
	name: 'Regions',
	url: '/regions',
	icon: 'map',
}];

export default class Region extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');

		this.state = {
			...this.state,
			name: '',
		}
	}

	handleData = (data) => {
		this.setState({name: data.name});
	}

	render() {
		let {match, history, baseUrl, reloadShell} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/regions/${match.params.id}`,
				icon: 'map-marker',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Region" value="details"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
				  <Objects.Region
						id={match.params.id}
						history={history}
						onData={this.handleData}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						goBack={true}
					/>
				</div>

			</div>
		)
	}
};